import { Children, ReactElement, ReactNode } from "react";
import React from "react";

import FeatureGates from "@atlassian/feature-gate-js-client";

import { ScrollTracking } from "../scroll-tracking";
interface ParentScrollProps {
    children: ReactElement | ReactNode;
    featureGate: string;
    pageId?: string;
}
interface NamedComponent extends React.Component {
    displayName: string;
}

type Child =
    | string
    | number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | ReactElement<any, string | React.JSXElementConstructor<any>>
    | Iterable<ReactNode>
    | React.ReactPortal;

export const ParentScrollTracking = (props: ParentScrollProps) => {
    const arrayChildren = Children.toArray(props.children);
    const definedName = (child: Child) => {
        if (React.isValidElement(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type as unknown as NamedComponent;
            return namedComponent.displayName;
        } else {
            return undefined;
        }
    };
    //if a feature gate is passed, check if the feature gate is enabled, otherwise default to true
    const trackScrolling = props.featureGate
        ? FeatureGates.checkGate(props.featureGate)
        : true;

    return (
        <>
            {Children.map(arrayChildren, (child, index) =>
                trackScrolling && definedName(child) ? (
                    <ScrollTracking
                        key={index}
                        index={`${index}/${arrayChildren.length}`}
                        section={definedName(child)}
                        pageId={props.pageId}
                    >
                        {child}
                    </ScrollTracking>
                ) : (
                    child
                )
            )}
        </>
    );
};
